import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import PlaceSearchList from './PlaceSearchList';

function PlacesSearch(props) {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  const renderPlacesSearch = () => {
    const placesSearch = loadPlacesSearch();
    if (placesSearch) {
      return (
        <div className="row">
          <PlaceSearchList placesSearch={placesSearch} />
        </div>
      );
    }
  };

  const loadPlacesSearch = () => {
    const { placesSearch } = props;
    if (placesSearch) {
      let places = [];
      for (var key in placesSearch) {
        var value = { ...placesSearch[key] };
        value.id = key;
        places.push(value);
      }
      return places;
    }
  };

  return (
    <div className="dashboard container">
      {renderPlacesSearch()}
      <Link className="btn-floating btn-large fixed-action-btn green right" to="newPlaceSearch">
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    placesSearch: state.firestore.data.placesSearch,
    auth: state.firebase.auth,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: 'placesSearch',
      orderBy: ['companyName', 'asc'],
    },
  ]),
)(PlacesSearch);
